"use strict";

import React, {Component} from 'react';

class ContentContainer extends Component {

    constructor(props) {
        super(props);
    }

    render() {
        return (
            <div className="container-fluid">
                {this.props.children}
            </div>
        )
    }
}

export default ContentContainer;